<div class="sidenav sidenav-offcanvas position-fixed association-settings" id="assSidenav" aria-label="Comment">
    <header class="sidenav__header d-flex justify-content-center align-items-center">
        <ul class="list-inline text-left col p-0">
            <li class="list-inline-item notes">Settings</li>
        </ul>

        <ul class="list-inline text-right col p-0">
            <li class="list-inline-item">
                <button type="button" class="btn btn-primary" (click)="onSave();" [disabled]="addedMetdataList && addedMetdataList.length===0">Save</button>
            </li>
            <li class="list-inline-item">
                <button type="button" (click)="closeNav();" class="btn btn-icon" id="assSettingsClose">
                    <em class="material-icons-outlined font-4x">close</em>
                </button>
            </li>
        </ul>
    </header>
    <section>
        <p class="text-gray font-1x mb-1">Metadata</p>

        <div class="row mx-0 mb-2">
            <div class="col-5 px-0">
                <app-multi-select-dropdown #multiSelect [label]="'key'" [viewLocation]="'acmt-search'" [customCol]="true" [data]="additionalMetadataList"
                    id="{{'-multiselect-keys'}}" [dropdownSettings]="moreFilterDropdownSettings" (SelectEvent)="captureKeys($event);"
                    [placeholder]="'Add more metadata'">
                </app-multi-select-dropdown>
            </div>
        </div>
        <form [formGroup]="form">
            <div class="border mb-2">
                <ng-container *ngFor="let controls of addedMetdataList; let i = index;">
                    <div class="row mx-0 settings-item">
                        <div class="col-5 pt-2">
                            <label class="mb-0" for="{{controls.name}}"> {{controls.name}}
                                <span *ngIf="controls.is_mandatory === 1" class="font-bold mandatory" aria-hidden="true">*</span>
                            </label>
                        </div>

                        <div class="col-4 px-0">
                            <input *ngIf="controls.field_type_id === 1" id="{{controls.metadata_id}}" class="form-control font-bold" [attr.aria-label]="'Please enter '+controls.name"
                                formControlName="{{controls.metadata_id}}" type="text" (keyup)="updateAddedMetadataValues(controls,$event.target.value)">

                            <ng-container *ngIf="controls.field_type_id === 2">
                                <textarea id="{{controls.metadata_id}}" class="form-control font-bold" [attr.aria-label]="'Please enter ' +controls.name"
                                    [formControl]="form.controls[controls.metadata_id]" (keyup)="updateAddedMetadataValues(controls,$event.target.value)"></textarea>
                            </ng-container>

                            <input *ngIf="controls.field_type_id===6" type="text" class="form-control font-bold" [attr.aria-label]="'Please enter '+controls.name"
                                formControlName="{{controls.metadata_id}}" (keypress)="isNumber($event)" (keyup)="updateAddedMetadataValues(controls,$event.target.value)">

                            <input *ngIf="controls.field_type_id===5" class="form-control font-bold" type="text"  formControlName="{{controls.metadata_id}}"
                                (ngModelChange)="updateAddedMetadataValues(controls,$event)"  atp-time-picker />

                            <my-date-picker *ngIf="controls.field_type_id===4" id="{{controls.metadata_id}}" [options]="myDatePickerOptionsStartDate"
                                formControlName="{{controls.metadata_id}}" (dateChanged)="updateAddedMetadataValues(controls,$event.formatted)"></my-date-picker>

                            <select id="{{controls.metadata_id}}" *ngIf="controls.field_type_id===3" (change)="updateAddedMetadataValues(controls,$event.target.selectedOptions[0]['label'])"
                                class="form-control custom-select" formControlName="{{controls.metadata_id}}">
                                <option [ngValue]="val" *ngFor="let val of controls.field_possible_values">{{ val }}</option>
                            </select>

                            <select id="{{controls.metadata_id}}" *ngIf="controls.field_type_id===7" (change)="updateAddedMetadataValues(controls,$event.target.selectedOptions[0]['label'])"
                                class="form-control custom-select" formControlName="{{controls.metadata_id}}">
                                <option [ngValue]="val" *ngFor="let val of controls.field_possible_values">{{ val?.value?.split('#||#')[0] }} 
                                </option>
                            </select>
                        </div>

                        <div class="col-3 text-right">
                            <button [attr.aria-label]="'Remove'" *ngIf="controls.can_delete===1" class="btn btn-icon tooltip top top-right d-inline-block"
                                data-tooltip="Remove" (click)="removeMetadata(controls)">
                                <span class="material-icons-outlined font-4x" aria-hidden="true">delete</span>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>


    </section>
</div>